<template>
	<div>
		<label
			:class="[
				{
					'form-check-label': !customLabelClass,
					[customLabelClass]: customLabelClass,
				},
			]"
			:for="inputFieldOptions.displayName"
			>{{ inputFieldOptions.displayName }}
			{{ inputFieldOptions.isRequired && inputFieldOptions.displayName ? " (Required)" : "" }}</label
		>
		<textarea
			v-if="inputFieldOptions.type.toLowerCase() == 'textarea'"
			:class="[
				{
					'form-control': !customInputClass,
					[customInputClass]: customInputClass,
					'input-w-icon': hasIcon,
				},
			]"
			type="textarea"
			:placeholder="`${inputFieldOptions.displayName} ${
				inputFieldOptions.isRequired == 'true' ? '(required)' : ''
			}`"
			:required="inputFieldOptions.isRequired == 'true'"
			v-model="inputValue"
			@change="$emit('inputValue', inputValue)"
			:tabindex="tabIndex"
			:disabled="disabled"
			:readonly="readonly"
		/>
		<div v-else-if="inputFieldOptions.type.toLowerCase() == 'select'">
			<select
				:class="[{ 'form-control': !customInputClass, customInputClass }]"
				type="search"
				:placeholder="`${inputFieldOptions.displayName} ${
					inputFieldOptions.isRequired == 'true' ? '(required)' : ''
				}`"
				:required="inputFieldOptions.isRequired == 'true'"
				v-model="inputValue"
				@change="$emit('inputValue', inputValue)"
				:tabindex="tabIndex"
				:disabled="disabled || readonly"
			>
				<option
					v-for="option in inputFieldOptions.SelectOptions"
					:key="option.Value"
					:value="option.Value"
				>
					{{ option.displayName }}
				</option>
			</select>
		</div>
		<div
			class="mb-2"
			v-else-if="inputFieldOptions.type.toLowerCase() == 'checkbox'"
		>
			<div
			    v-if="JSON.parse(inputFieldOptions.properties)[`CheckboxItems`]"
				class="form-check"
				v-for="(checkbox, index) in  (JSON.parse(inputFieldOptions.properties)[`CheckboxItems`])"
				:key="index"
			>
				<input
					type="checkbox"
					:value="checkbox.value"
					:id="checkbox.value"
					v-model="inputValue[checkbox.value]"
					class="form-check-input"
					@change="$emit('inputValue',Object.keys(inputValue).find(k => inputValue[k]==true)?inputValue:null)"
					:tabindex="tabIndex"
					:disabled="disabled"
					:readonly="readonly"
				/>
				<label
					:class="[
						{
							'form-check-label': !customLabelClass,
							[customLabelClass]: customLabelClass,
						},
					]"
					:for="checkbox.value"
					>{{ checkbox.displayName }}</label
				>
			</div>
		</div>
		<div
			class="mb-2 d-flex flex-column"
			v-else-if="inputFieldOptions.type.toLowerCase() == 'radio'"
		>
			<b-form-radio-group
				:id="inputFieldOptions.displayName"
				:buttons="inputFieldOptions.radioStyle.toLowerCase() == 'buttons'"
				v-model="inputValue"
				html-field="DisplayName"
				:options="inputFieldOptions.RadioButtonItems"
				@change="$emit('inputValue', inputValue)"
				button-variant="outline"
				:tabindex="tabIndex"
				:disabled="disabled || readonly"
			>
			</b-form-radio-group>
		</div>
		<div
			class="d-flex justify-content-between mb-2"
			v-else-if="inputFieldOptions.type.toLowerCase() == 'range'"
		>
			<input
				class="d-flex flex-grow-2"
				type="range"
				:min="inputFieldOptions.Start"
				:max="inputFieldOptions.End"
				:step="inputFieldOptions.Step"
				oninput="this.nextElementSibling.innerHTML = this.value"
				:tabindex="tabIndex"
				:disabled="disabled"
				:readonly="readonly"
			/>
			<output class="d-flex flex-grow-1 justify-content-center"></output>
		</div>
		<div
			class="d-flex justify-content-between mb-2"
			v-else-if="inputFieldOptions.type.toLowerCase() == 'tel'"
		>
			<vue-tel-input
				:class="`${customInputClass ? customInputClass : 'form-control'} ${
					isPhoneError && showError ? 'error' : ''
				}`"
				defaultCountry="PK"
				:inputOptions="telInputOptions"
				validCharactersOnly
				v-model="inputValue"
				@input="validate"
				@blur="showError = true"
				@focus="showError = false"
				:autoFormat="true"
				mode="national"
				invalidMsg="Please enter a valid phone number"
				id="mobile"
				:disabled="readonly || disabled"
			></vue-tel-input>
		</div>
		<div class="form-group" v-else>
			<input
				:class="[
					{
						'form-control': !customInputClass,
						[customInputClass]: customInputClass
					},
				]"
				:type="inputFieldOptions.type.toLowerCase()"
				:placeholder="`${inputFieldOptions.displayName} ${
					inputFieldOptions.isRequired == 'true' ? '(required)' : ''
				}`"
				:required="inputFieldOptions.isRequired == 'true'"
				v-model="inputValue"
				@change="$emit('inputValue', inputValue)"
				:tabindex="tabIndex"
				:disabled="disabled"
				:readonly="readonly"
			/>
		</div>
	</div>
</template>

<script>
const getCountryISO3 = require("country-iso-2-to-3");

export default {
	name: "DynamicCustomFormInput",
	props: {
		inputFieldOptions: Object,
		customInputClass: { type: String, default: null },
		hasIcon: Boolean,
		customLabelClass: { type: String, default: null },
		tabIndex: Number,
		inputSetValue: { type: String, default: null },
		disabled: Boolean,
		readonly: Boolean,
	},
	data() {
		return {
			inputValue: null,
			phone: null,
			isPhoneError: false,
			showError: false,
			telInputOptions: {
				autocomplete: "on",
				maxlength: 15,
				tabindex: this.$props.tabIndex,
				placeholder: this.$props.inputFieldOptions.displayName,
				mode: "national",
			},
		};
	},
	methods: {
		validate(num, obj) {
			// console.log(num, obj);
			if (obj.valid != null && obj.valid === false) {
				this.isPhoneError = true;
				return;
			}
			this.isPhoneError = false;
			if (obj.country && obj.country.iso2) {
				this.countryCode = getCountryISO3(obj.country.iso2);
				this.phone = obj.number;
				this.$emit("inputValue", this.phone);
			}
			return false;
		},
	},
	created() {
		// console.log(this.inputSetValue);
		if (this.inputFieldOptions.type.toLowerCase() == "tel") { 
			console.log(this.inputSetValue);
			if (this.inputSetValue) this.phone = this.inputSetValue ?? null;
			if (this.inputSetValue) this.inputValue = this.inputSetValue ?? null;
			this.phone = this.inputFieldOptions.value ?? null;
			return;
		}
		this.inputValue = this.inputFieldOptions.value ?? null;
		if (this.inputSetValue) this.inputValue = this.inputSetValue ?? null;
		if (this.inputFieldOptions.type.toLowerCase() == "checkbox" && this.inputFieldOptions.properties) {
			if(!this.inputValue)
			{
				this.inputValue={};
			}
			JSON.parse(this.inputFieldOptions.properties).CheckboxItems.forEach((item) => {
				debugger;
				this.inputValue[item.value] = item.checked && item.checked=="true"?true: null;
			});
		}
		if(this.inputFieldOptions.value)
		{			
			this.$emit('inputValue', this.inputFieldOptions.value);
		}
	},
};
</script>

<style scoped>
.flex-grow-2 {
	flex-grow: 2 !important;
}
</style>
